import { render, staticRenderFns } from "./AdminCategories.vue?vue&type=template&id=fb5eab00&scoped=true&"
import script from "./AdminCategories.vue?vue&type=script&lang=js&"
export * from "./AdminCategories.vue?vue&type=script&lang=js&"
import style0 from "./AdminCategories.vue?vue&type=style&index=0&id=fb5eab00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5eab00",
  null
  
)

export default component.exports